import { useEffect, useState } from 'react';
import { getCountdownString } from '@library/component-utils/dateTime';

export const CountdownTimer = ({
  targetDate,
  className
}: {
  targetDate: string;
  className: string;
}) => {
  const [countdown, setCountdown] = useState(getCountdownString(targetDate));

  useEffect(() => {
    const interval = setInterval(() => {
      setCountdown(getCountdownString(targetDate));
    }, 1000);

    return () => clearInterval(interval); // Cleanup
  }, [targetDate]);

  return <span className={className}>{countdown}</span>;
};
